import { clearUserData } from '@/shared'

export const Logout = ({ children }) => {
	const onClick = () => {
		clearUserData()
		window.location.href = process.env.REACT_APP_LOGOUT_REDIRECT
	}
	return <span onClick={onClick}>{children}</span>
}
